/**
 * Counts the number of top-level columns in a `grid-template-columns` string. Tokens nested inside
 * parentheses (e.g. `minmax(min-content, 1fr)`) count as a single column. Whitespace-only tokens
 * are ignored, so leading/trailing spaces never inflate the count.
 *
 * Note: a multi-track function like `repeat(3, 1fr)` is counted as ONE column (it expands to three at
 * layout time), which would desync `columnCount` from the real track count that Loader/SubRow rely on.
 * No `Head.column` currently passes `repeat()`; avoid it (list tracks explicitly) until this is handled.
 */
export function countColumns(columns) {
    let depth = 0;
    let count = 0;
    for (const token of columns.split(/\s+/).filter(Boolean)) {
        const opens = (token.match(/\(/g) || []).length;
        const closes = (token.match(/\)/g) || []).length;
        depth += opens - closes;
        if (depth === 0) {
            count++;
        }
    }
    return count;
}
